"use client";

import * as motion from "motion/react-client";
import { useEffect, useRef } from "react";
import { MotionValue, useAnimationFrame, useMotionValue } from "motion/react";

export function Cube({
  x = 300,
  y = 200,
  z = 100,
  perspective = 400, // 定义摄像机到屏幕的距离 : 100px ~ 2000px | none
  color = "var(--yz-foreground)",
  action
}: {
  x: number;
  y: number;
  z: number;
  perspective?: number;
  color?: string | MotionValue<string>;
  action?:
    | "show-front"
    | "show-back"
    | "show-left"
    | "show-right"
    | "show-top"
    | "show-bottom";
}) {
  const halfX = Math.floor(x / 2);
  const halfY = Math.floor(y / 2);
  const halfZ = Math.floor(z / 2);

  const ref = useRef<HTMLDivElement>(null);

  // useAnimationFrame((time, delta) => {
  //   if (!ref.current) return;
  //   const rotate = Math.sin(time / 10000) * 360;
  //   const y = (1 + Math.sin(time / 1000)) * -10;
  //   ref.current.style.transform = `translateY(${y}px) rotateX(${rotate}deg) rotateY(${rotate}deg)`;
  // });

  const transform = useMotionValue("");
  useEffect(() => {
    switch (action) {
      case "show-front":
        // transform.set(`translateZ(-${halfZ}px) rotateY(0deg)`);
        transform.set(`rotateY(0deg)`);
        break;
      case "show-back":
        // transform.set(`translateZ(-${halfZ}px) rotateY(-180deg)`);
        transform.set(`rotateY(-180deg)`);
        break;
      case "show-left":
        // transform.set(`translateZ(-${halfX}px) rotateY(90deg)`);
        transform.set(`rotateY(90deg)`);
        break;
      case "show-right":
        // transform.set(`translateZ(-${halfX}px) rotateY(-90deg)`);
        transform.set(`rotateY(-90deg)`);
        break;
      case "show-top":
        // transform.set(`translateZ(-${halfY}px) rotateX(-90deg)`);
        transform.set(`rotateX(-90deg)`);
        break;
      case "show-bottom":
        // transform.set(`translateZ(-${halfY}px) rotateX(90deg)`);
        transform.set(`rotateX(90deg)`);
        break;
    }
  }, [action, halfX, halfY, halfZ]);

  return (
    <div
      className="camera"
      style={{ width: x, height: y, perspective }}>
      <motion.div
        ref={ref}
        className="cube"
        style={{
          width: x,
          height: y,
          transition: "transform 1s",
          transform
        }}>
        <motion.div
          className="surface front"
          style={{
            width: x,
            height: y,
            transform: `rotateY(0deg) translateZ(${halfZ}px)`,
            backgroundColor: "var(--yz-rainbow-red)"
          }}>
          front
        </motion.div>
        <motion.div
          className="surface back"
          style={{
            width: x,
            height: y,
            transform: `rotateY(180deg) translateZ(${halfZ}px)`,
            backgroundColor: "var(--yz-rainbow-indigo)"
          }}>
          back
        </motion.div>
        <motion.div
          className="surface left"
          style={{
            width: z,
            height: y,
            left: halfX - halfZ,
            transform: `rotateY(-90deg) translateZ(${halfX}px)`,
            backgroundColor: "var(--yz-rainbow-orange)"
          }}>
          left
        </motion.div>
        <motion.div
          className="surface right"
          style={{
            width: z,
            height: y,
            left: halfX - halfZ,
            transform: `rotateY(90deg) translateZ(${halfX}px)`,
            backgroundColor: "var(--yz-rainbow-yellow)"
          }}>
          right
        </motion.div>
        <motion.div
          className="surface top"
          style={{
            width: x,
            height: z,
            top: halfY - halfZ,
            transform: `rotateX(90deg) translateZ(${halfY}px)`,
            backgroundColor: "var(--yz-rainbow-green)"
          }}>
          top
        </motion.div>
        <motion.div
          className="surface bottom"
          style={{
            width: x,
            height: z,
            top: halfY - halfZ,
            transform: `rotateX(-90deg) translateZ(${halfY}px)`,
            backgroundColor: "var(--yz-rainbow-blue)"
          }}>
          bottom
        </motion.div>
      </motion.div>
      <StyleSheet></StyleSheet>
    </div>
  );
}

function StyleSheet() {
  return (
    <style>{`
      .camera {
        perspective-origin: 50% 50%;
        /* animation: cameraMove 2s ease-out infinite alternate both; */
      }

      /*
      @keyframes cameraMove {
        0% {
          perspective-origin: 50% 180px;
        }
        100% {
          perspective-origin: 50% -200px;
        }
      }
      */

      .cube {
        position: relative;
        transform-style: preserve-3d;
      }

      .cube .surface {
        position: absolute;
        opacity: 0.6;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        backface-visibility: visible;
      }

    `}</style>
  );
}
